import React from 'react'

const Story = () => {
  return (
    <>
    <div className="container">
        <div className="row ram">
            <h1>Personal Style Stories!</h1>
        </div>
    </div>
    <section>
        <div className="container">
            <div className="row">
                <div className="  col-sm-4 py-3 py-sm-0">
                    <div className="card1">
                        <img className="img-fluid"
                            src="https://64.media.tumblr.com/43ea8b0372c93d89519438939f02ec3d/tumblr_p9kv1lYXWc1uo5kq6o1_1280.jpg"
                            className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Winter Style</h5>
                            <p className="card-text">Some quick example text to build on the card title and make up the bulk
                                of the card's
                                content.</p>
                            <a href="http://127.0.0.1:5500/makeup.html" className="btn btn-light">Read more</a>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4 py-3 py-sm-0">
                    <div className="card1">
                        <img className="img-fluid"
                            src="https://i.pinimg.com/originals/7a/2a/80/7a2a807a3313a27554a01abc915b0dbd.jpg"
                            className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Street Shoping</h5>
                            <p className="card-text">Some quick example text to build on the card title and make up the bulk
                                of the card's
                                content.</p>
                            <a href="#" className="btn btn-light">Read More</a>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4 py-3 py-sm-0">
                    <div className="card1">
                        <img className="img-fluid" id="n" src="https://m.media-amazon.com/images/I/91CeMh5A+LL._UL1500_.jpg"
                            className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Summer Style</h5>
                            <p className="card-text">Some quick example text to build on the card title and make up the bulk
                                of the card's
                                content.</p>
                            <a href="#" className="btn btn-light">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default Story
